import { TIME_IN_MS } from '@utils';

export const ONBOARDING_TIMEOUT = TIME_IN_MS.ONE_MINUTE;
